/**
 * Header Navigation Buttons
 * Handles navigation for header buttons (Wishlist, Account)
 * Ensures proper keyboard accessibility with Enter and Space key support
 */

class HeaderNavButtons extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    // Handle click events on header navigation buttons
    this.listeners.add(
      document.documentElement,
      'click',
      this.handleButtonClick.bind(this),
    )
  }

  handleButtonClick (e) {
    const button = e.target.closest('[data-header-nav-button]')
    if (!button) return

    const navUrl = button.getAttribute('data-nav-url')
    if (navUrl) {
      window.location.href = navUrl
    }
  }
}

customElements.define('header-nav-buttons', HeaderNavButtons)
